const styles = {
    lineItemContainer: {
      display: 'flex',
      borderRadius: 6,
      marginBottom: 12,
      minHeight: 60,
      backgroundColor: '#fefefe',
    },
      matchBlock: {
        marginBottom: '48px',
        padding: '0px 24px 48px 20px',
        boxSizing: 'border-box',
        flexDirection: 'column',
        overflow: 'visible',
        //boxShadow: '5px 5px 12px rgba(0, 0, 0, 0.6)'
    },
      matchHeader: {
        position: 'relative',
        overflow: 'visible',
      },
      statusIcon: {
        position: 'absolute',
        top: -16,
        left: -16,
        transform: 'none',
        width: 34,
        height: 'auto',
        zIndex: '9999'
      },
      userModifiedIcon: {
        position: 'absolute',
        top: -16,
        right: -16,
        transform: 'none',
        width: 32,
        height: 'auto',
        zIndex: '9999'
      },
      matchDetails: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        marginTop: 8,
        boxSizing: 'border-box',
        overflow: 'visible',
      },
      docBlock: {
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        flexDirection: 'row',
      },
      doc1: {
        backgroundColor: '#f9f9f9',
      },
      doc2: {
        background: 'none',
      },
      doc1InfoContainer: {
        width: '14%',
        minWidth: '170px',
        backgroundColor: '#42999d',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
      },
      li1InfoContainer: {
        width: 'auto',
        flex: '1 1 0%',
        minWidth: 0,
        backgroundColor: '#49a7ab',
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'visible',
      },
      doc2InfoContainer: {
        width: '14%',
        minWidth: '170px',
        backgroundColor: '#e5e9e8',
        display: 'flex',
        boxSizing: 'border-box',
        flexDirection: 'column',
      },
      li2InfoContainer: {
        width: 'auto',
        flex: '1 1 0%',
        minWidth: 0,
        backgroundColor: '#f2f2f2',
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'visible',
      },
      showRefDoc1: {
        background: 'none',
        border: 'none',
        color: 'white',
        fontStyle: 'italic',
        textDecoration: 'underline',
        padding: '6px 0px'
      },
      showRefDoc2: {
        background: 'none',
        border: 'none',
        color: 'black',
        fontStyle: 'italic',
        textDecoration: 'underline',
        padding: '6px 0px'
      },
      description: {
        fontWeight: 'bold',
        marginBottom: 8,
        paddingLeft: '8px',
        fontSize: 16,
        display: 'flex',
        alignItems: 'center'
      },
      tableContainer: {
        maxWidth: '100%',
        overflow: 'visible',
      },
      headerRow: {
        display: 'flex',
        marginBottom: 4,
        userSelect: 'none',
      },
      headerCell: {
        padding: '4px 8px',
        fontWeight: 'bold',
        fontSize: 13,
        lineHeight: 1.4,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        position: 'relative',
        flexDirection: 'column'
      },
      crossOut: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '80%',
        height: 2,
        backgroundColor: 'red',
        transform: 'translate(-50%, -50%) rotate(-45deg)',
        pointerEvents: 'none',
      },
      carousel: {
        display: 'flex',
        overflowX: 'auto',
        scrollbarWidth: 'thin',
        scrollbarColor: '#ccc transparent',
        flexDirection: 'row'
      },
      valueCell: {
        padding: '4px 8px',
        margin: 0,
        fontSize: 14,
        lineHeight: 1.4,
        textAlign: 'left',
        whiteSpace: 'nowrap',
      },
      oddCell1: {
        backgroundColor: '#489ea3',
      },
      evenCell1: {
        backgroundColor: '#42999d',
      },
      oddCell2: {
        backgroundColor: '#eaeaea',
      },
      evenCell2: {
        backgroundColor: '#d9dddc',
      },
      footerRow: {
        display: 'flex',
        marginTop: 8,
        borderTop: '1px solid #aaa',
        paddingTop: 4,
        fontSize: 13,
        fontWeight: 'bold',
      },
      footerCell: {
        padding: '4px 8px',
        textAlign: 'left',
        whiteSpace: 'nowrap',
      },
      searchBox: {
        width: '100%',
        boxSizing: 'border-box',
        margin: '0px 0px 0px 0px',
        position: 'relative',
        zIndex: '9998', 
      },
      searchInput: {
        padding: '6px 8px 6px 24px',
        boxSizing: 'border-box',
        width: '100%',
        backgroundColor: '#eff0f0',
        fontSize: 14,
        borderRadius: '16px',
        border: 'none',
        boxSizing: 'border-box',
      },   
      searchIcon: {
        position: 'absolute',
        width: '14px',
        height: 'auto',
        zIndex: '9998', 
        margin: '0px 0px 0px 6px',
        bottom: '25%',
        left: 0
      }, 
      resultBtn: {
        cursor: 'pointer',
        padding: '4px 8px',
        borderBottom: '1px solid #ccc',
        backgroundColor: '#f9f9f9',
        marginBottom: 2
      },
      matchBlockFoooter: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between'
      },
      searchContainer: {
        width: '13%',
        padding: '16px',
        boxSizing: 'border-box'
      },
      deltasContainer: {
        width: '74%',
        padding: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        overflow: 'auto',
        boxSizing: 'border-box'
      },
      columnMath: {
        display: 'flex', 
        flexDirection: 'row',
        justifyContent: 'space-between', 
        fontSize: 14, 
        fontWeight: 500
      },
      scrollableBlock: {
        overflowX: 'hidden',
        maxWidth: '100%'
      },
      carouselRow: {
        display: 'flex',
        flexDirection: 'row',
        width: 'max-content'
      },
      triangleRight: {
        width: 0,
        height: 0,
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
        borderLeft: '10px solid #2e3a59',
        marginLeft: '6px'
      },
      triangleLeft: {
        width: 0,
        height: 0,
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
        borderRight: '10px solid #2e3a59',
        marginRight: '6px'
      },
      subtotalRow: {
        display: 'flex',
        flexDirection: 'row',
        padding: '0px',
        maxWidth: '80%',
        boxSizing: 'border-box'
      },
      footerCell: {
        minWidth: '100px',
        padding: '4px 8px',
        borderTop: '1px solid #ccc',
        textAlign: 'right',
      },
      crossColumnMath: {
        display: 'flex', 
        position: 'relative',
        fontSize: 16,
        fontWeight: 'normal', 
        color: '#444', 
        width: '100%',
        justifyContent: 'center'
      },
      footerCell: {
        padding: '4px 16px',
        fontWeight: 'bold',
        fontSize: '13px',
        lineHeight: '1.4',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column'
      },
      buttonsContainer: {
        display: 'flex',
        padding: '16px 8px 16px 24px',
        justifyContent: 'space-between',
        flexDirection: 'column',
        width: '13%',
        boxSizing: 'border-box',
        alignItems: 'end'
      },
      addBtn1: {
        padding: '8px',
        cursor: 'pointer',
        backgroundColor: '#5b5d5d',
        color: 'white',
        border: 'none',
        width: '100px'
      },
      addBtn2: {
        padding: '8px',
        cursor: 'pointer',
        backgroundColor: '#489ea3',
        color: 'white',
        border: 'none',
        width: '100px'
      },
      removeBtn1: {
        padding: '8px',
        cursor: 'pointer',
        backgroundColor: '#457c81',
        color: 'white',
        border: 'none',
        width: '100px'
      },
      removeBtn2: {
        padding: '8px',
        cursor: 'pointer',
        backgroundColor: '#5b5d5d',
        color: 'white',
        border: 'none',
        width: '100px'
      }
    };
  
  export default styles;
  
